import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { defaultBenefits } from "../../models/benefit";

@Component({
  selector: 'app-days',
  templateUrl: './days.component.html',
  styleUrls: ['./days.component.scss']
})
export class DaysComponent implements OnInit {

  title = "";
  hintText = "";
  minValue = 0;
  maxValue = 1;

  companies = [];
  idBenefit = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<DaysComponent>
    ) { 
    this.companies = data.companies;
    this.idBenefit = data.benefit.id;
    
    for (const companie of this.companies) {
      
      // con arreglos
      /* if (!companie.benefits.find(benefit => (this.idBenefit === benefit.id))) {
        console.log(companie.name + " no tiene el beneficio ", this.idBenefit);
        const newBenefit =  defaultBenefits.find(benefit => this.idBenefit === benefit.id)
        companie.benefits.push(newBenefit);
      } */

      // con objetos
      if (!companie.benefits[(this.idBenefit).toString()]) {
        const newBenefit =  { ...defaultBenefits.find(benefit => this.idBenefit === benefit.id)};
        companie.benefits[(this.idBenefit).toString()] = newBenefit;
      }
    }

    switch (this.idBenefit) {
      case 1:
        this.title = "Indica los días de aguinaldo";
        this.hintText = "# de días";
        this.minValue = 15;
        this.maxValue = 30;
        break;
      case 2:
        this.title = "Indica porcentaje de prima vacacional";
        this.hintText = "% porc"
        this.minValue = 25;
        this.maxValue = 100;
        break;
      case 3:
        this.title = "Indica importe de vales de despensa";
        this.hintText = "$ mes"
        this.minValue = 1;
        this.maxValue = data.benefit.upTo;
        break;
        
      case 4:
        this.title = "Indica importe de apoyo home office";
        this.hintText = "$ mes"
        this.minValue = 1;
        this.maxValue = data.benefit.upTo;
        break;
      
      case 5:
        this.title = "Indica importe de apoyo setup home office";
        this.hintText = "$ Único"
        this.minValue = 1;
        this.maxValue = data.benefit.upTo;
        break;
        
      default:
        break;
    }
  }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
